<div class="d-flex flex-column spacing-8" style="height: 100%">
  <div class="d-flex flex-column">
    @if (headingTitle()) {
      <h3 class="h3-bold primary-100">{{ headingTitle() }}</h3>
    }
    @if (subtitle()) {
      <h4 class="h4-reg primary-60">{{ subtitle() }}</h4>
    }
  </div>
  <div #heatmapContainer style="width: 100%; flex-grow: 1; min-height: 0"></div>
</div>
